export const PROVIDER_INTERRUPT_FALLBACK_ACTIVITY_KIND =
  "provider.turn.interrupt.fallback" as const;

export const PROVIDER_INTERRUPT_FALLBACK_SUMMARY = "Thread stopped locally" as const;

export const PROVIDER_INTERRUPT_FALLBACK_DETAIL =
  "The provider process was unavailable, so the thread was stopped locally." as const;
